import { useRouter } from 'next/router'

import { useIntl } from 'react-intl'
import { useQueryClient } from 'react-query'

import SelectFilter, {
  type SelectFilterProps
} from 'app/libs/elastic/filters/SelectFilter'
import { getSubCategories } from 'app/services/Api/listing'
import {
  getSearchCategoryId,
  getSubcategoryHeader
} from 'app/utils/helpers/listings.helpers'
import { isOfType } from 'app/utils/helpers/type.helpers'

type SearchSelectFilterProps = Omit<SelectFilterProps, 'field' | 'filterType'>

export const SubCategoryFilter = (props: SearchSelectFilterProps) => {
  const queryClient = useQueryClient()
  const { formatMessage } = useIntl()
  const { query } = useRouter()

  const searchCategory = isOfType.string(query.category) ? query.category : ''
  const categoryId = getSearchCategoryId({ searchCategory, queryClient })

  return (
    <SelectFilter
      field="sub_category_id.keyword"
      filterType="any"
      groupBy={getSubcategoryHeader}
      sortOption
      label={formatMessage({ defaultMessage: 'Sub-Category' })}
      optionSettings={{
        key: ['subcategories', categoryId],
        enabled: !!categoryId,
        loadOptions: () => getSubCategories({ by_category_id: categoryId }),
        optionValue: 'id',
        optionLabel: 'name'
      }}
      withFilter
      {...props}
    />
  )
}
